import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Syspi84Component } from './syspi84Pkg.component';
import { JackBaseComponentModule,MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-syspi84-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Syspi84Component,
    ],
  templateUrl: './syspi84BillPkg.component.html',
  styleUrls: [],
})
export class Syspi84BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' syspi84'; //###
  override masterPage!:  Syspi84Component;
  constructor() {
    super( );
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
